import type { Theme, Components } from '@mui/material/styles';

import { CbridgePalette } from './theme.constant';

const { hoverOverlay, focusOverlay, focusBorder } = CbridgePalette;

const {
  text,
  secondary,
  error,
} = CbridgePalette.button;

export const MuiButton: Components<Theme>['MuiButton'] = {
  defaultProps: {
    variant: 'contained',
    disableFocusRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => {
      const primary = theme.palette.brand.button;

      return {
        textTransform: 'capitalize',
        outlineOffset: '-1px',
        fontWeight: 500,
        fontSize: '14px',
        letterSpacing: '0.4px',

        color: text.main,
        '&:active': {
          color: text.pressed,
        },
        '&:disabled': {
          color: text.disabled,
        },

        variants: [
          {
            props: { variant: 'contained', color: 'primary' },
            style: {
              backgroundColor: primary.main,

              '&:hover': {
                backgroundColor: primary.hover,
              },

              '&: focus': {
                backgroundColor: `color-mix(in srgb, ${primary.active}, ${focusOverlay})`,
                outline: `solid color-mix(in srgb, ${primary.active}, ${focusBorder}) 1px`,
              },

              '&:disabled': {
                backgroundColor: primary.disabled,
              },
            },
          },
          {
            props: { variant: 'contained', color: 'secondary' },
            style: {
              backgroundColor: secondary.main,

              '&:hover': {
                backgroundColor: `color-mix(in srgb, ${secondary.main}, ${hoverOverlay})`,
              },

              '&:focus-visible': {
                outline: `solid color-mix(in srgb, ${secondary.main}, ${focusBorder}) 1px`,
              },

              '&:disabled': {
                backgroundColor: secondary.disabled,
              },
            },
          },
          {
            props: { variant: 'contained', color: 'error' },
            style: {
              backgroundColor: error.main,

              '&:hover': {
                backgroundColor: `color-mix(in srgb, ${error.active}, ${hoverOverlay})`,
              },

              '&: focus': {
                backgroundColor: `color-mix(in srgb, ${error.active}, ${focusOverlay})`,
                outline: `solid color-mix(in srgb, ${error.active}, ${focusBorder}) 1px`,
              },

              '&:disabled': {
                backgroundColor: error.disabled,
              },
            },
          },
        ],
      };
    },
  },
};
